import apiPath from '../constants/apiPath';
import _ from 'lodash';

async function Http(path, options) {
  let BaseURL = apiPath.baseURL;
  let noAuth = ["api/admins/login"];

  let token = localStorage.getItem("admin") ? JSON.parse(localStorage.getItem("admin")).admin.token : '';
  console.log(options.headers)
  options.headers["x-access-token"] = token;

  let result = await fetch(BaseURL + path, options);

  if (result.status === 401) {
    localStorage.removeItem("admin");
    window.location.reload();
  }
  return result;
}
export default Http;
